import React from "react";

const OverviewBlockViews = (props) => {
  const { dataBlock, darkMode, renderIcon, renderValue, renderTrend } = props;

  const renderTitleText = (title) => {
    switch (title) {
      case "facebook":
        return "Page Views";
      case "twitter":
        return "Retweets";
      case "instagram":
        return "Profile Views";
      case "youtube":
        return "Total Views";
      default:
    }
  };

  return (
    <div
      className={
        darkMode
          ? "overviewblock-views subblock card_dark"
          : "overviewblock-views subblock card_light"
      }>
      <div className="overviewblock-views-title_text dashboard_dark_secondarytext">
        {renderTitleText(dataBlock.title)}
      </div>
      <div className="overviewblock-views-title_icon">
        {renderIcon(dataBlock.title)}
      </div>

      <div
        className={
          darkMode
            ? "overviewblock-views-data_value dashboard_dark_maintext"
            : "overviewblock-views-data_value dashboard_light_maintext"
        }>
        {renderValue(dataBlock.viewsCurrent)}
      </div>
      <div className="overviewblock-views-data_trend trend">
        {renderTrend(dataBlock.viewsLast, dataBlock.viewsCurrent)}
      </div>
    </div>
  );
};

export default OverviewBlockViews;
